import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from "../../../shared";
import {TaskQueueOutboundContainerModel} from "../../../../../../../models/aggregates/alg/cc/task-queue";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { Observable } from "rxjs";
import { TaskSummaryResponseDto } from "../../../../data-transfer-objects/alg/cc/task-summary-response-dto.model";
import { TaskAssignmentRecentHistoryDto } from "../../../../data-transfer-objects/alg/cc";

@Injectable({providedIn: "root"})
export class TaskQueueOutboundService extends BaseApiTemplateService<TaskQueueOutboundContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'outbound-task-queues';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'outbound-task-queues';
    this.httpClient = http;
  }

  deletePermanent(taskQueueGuid: string, visa: ApiVisa): Observable<ApiResponseModel<TaskQueueOutboundContainerModel>> {
    let url = this.apiUrl + '/permanent/' + taskQueueGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/permanent/' + taskQueueGuid;
    }
    return this.httpClient.delete<ApiResponseModel<TaskQueueOutboundContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getAllTaskSummary(visa: ApiVisa): Observable<ApiResponseModel<TaskSummaryResponseDto>> {
    let url = this.apiUrl + '/all-task-summary';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/all-task-summary';
    }
    return this.httpClient.get<ApiResponseModel<TaskSummaryResponseDto>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getMyTaskSummary(loginSubjectGuid: string, visa: ApiVisa): Observable<ApiResponseModel<TaskSummaryResponseDto>> {
    let url = this.apiUrl + '/my-task-summary/' + loginSubjectGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/my-task-summary/' + loginSubjectGuid ;
    }
    return this.httpClient.get<ApiResponseModel<TaskSummaryResponseDto>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getMyTeamTaskSummary(loginSubjectGuid: string, visa: ApiVisa): Observable<ApiResponseModel<TaskSummaryResponseDto>> {
    let url = this.apiUrl + '/my-team-task-summary/' + loginSubjectGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/my-team-task-summary/' + loginSubjectGuid;
    }
    return this.httpClient.get<ApiResponseModel<TaskSummaryResponseDto>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public publishTaskQueueAndTaskSummary(
    taskAssignmentRecentHistoryDtoObject: TaskAssignmentRecentHistoryDto,
    appletGuid: string,     
    visa: ApiVisa
    ): Observable<ApiResponseModel<TaskAssignmentRecentHistoryDto>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {      
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    url = this.apiUrl + '/publish-task-queue?appletGuid=' + appletGuid;
    return this.httpClient.post<ApiResponseModel<TaskAssignmentRecentHistoryDto>>(
      url,
      taskAssignmentRecentHistoryDtoObject,
      this.getHttpHeader(visa)
    );
  }
}
